import { render, staticRenderFns } from "./labelProducts.vue?vue&type=template&id=aa24c164&scoped=true&"
import script from "./labelProducts.vue?vue&type=script&lang=js&"
export * from "./labelProducts.vue?vue&type=script&lang=js&"
import style0 from "./labelProducts.vue?vue&type=style&index=0&id=aa24c164&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa24c164",
  null
  
)

export default component.exports